<script lang="ts" setup>
const $props = defineProps<{
	event: App.Data.EventData
}>()
</script>

<template>
	<div class="col-span-1 flex flex-col justify-between border border-gray-200">
		<div class="flex w-full grow justify-between space-x-3 p-3 md:space-x-6 md:p-6">
			<div class="flex flex-col">
				<div class="mb-2 flex items-center space-x-3">
					<h3 class="font-semibold">
						<router-link :href="route('event.show', { event: $props.event.uuid })">
							{{ $props.event.name }}
						</router-link>
					</h3>
				</div>
				<p class="mt-auto flex flex-col text-sm text-gray-500">
					<span v-if="event.start_date && event.end_date" class="flex items-center gap-2">
						<i-gg-calendar-today class="text-primary size-4 shrink-0" />
						{{ event.start_date === event.end_date ? event.start_date : `${event.start_date} - ${event.end_date}` }}
					</span>
					<span v-if="event.city && event.ioc_code" class="flex items-center gap-2">
						<i-gg-pin class="text-primary size-4 shrink-0" />
						{{ event.city }}, {{ t(`countries.ioc.${event.ioc_code.toUpperCase()}`) }}
					</span>
				</p>
			</div>
			<div class="w-[80px] shrink-0">
				<img v-if="event.logo_url" :src="event.logo_url" :alt="event.name" />
			</div>
		</div>
		<div class="border-t border-gray-200">
			<div class="-mt-px flex divide-x divide-gray-200">
				<router-link :href="route('event.files', { event: $props.event.uuid })" class="hover:text-primary -ml-px flex w-0 flex-1 items-center justify-center gap-2 py-4 text-sm font-semibold hover:bg-gray-200">
					<i-jstiming-files class="text-primary h-6 w-10" />
					{{ event.button_text_files ? event.button_text_files : t('app.files') }}
				</router-link>
				<router-link :href="route('event.show', { event: $props.event.uuid })" class="hover:text-primary -ml-px flex w-0 flex-1 items-center justify-center gap-2 py-4 text-sm font-semibold hover:bg-gray-200">
					{{ event.button_text_view ? event.button_text_view : t('app.results') }}
					<i-gg-chevron-double-right class="text-primary size-4" />
				</router-link>
			</div>
		</div>
	</div>
</template>
